import apiClient from './client';

export const indicatorsApi = {
  /** List registered research indicators */
  list: async () => {
    const response = await apiClient.get('/api/indicators');
    return response.data;
  },

  get: async (id) => {
    const response = await apiClient.get(`/api/indicators/${id}`);
    return response.data;
  },

  /**
   * Run an indicator for a symbol.
   * @param {string} id e.g. 'markov'
   * @param {{ symbol: string, [key: string]: any }} params
   */
  run: async (id, params = {}) => {
    const response = await apiClient.get(`/api/indicators/${id}/run`, { params });
    return response.data;
  },
};

export default indicatorsApi;
